export default __webpack_public_path__ + "static/media/OTD.815d0be2.svg";